import React from 'react';
import {
  Badge,
  Avatar,
  Box,
  makeStyles,
  Typography,
  Tooltip
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { map, get, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  characterImage: {
    width: '70px',
    height: '70px',
    backgroundColor: '#f2f2f2',
    boxShadow: '0px 0px 5px 5px #cdd2d2',
    border: '1px solid #cdd2d2',
    margin: '0.5rem',
    marginLeft: '0.7rem',
    marginRight: '0.7rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e1e6f4'
    }
  },
  characterSlider: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'auto',
    alignItems: 'center',
    flexGrow: 1,
    marginTop: 0,
    height: '100%',
    padding: '0.5rem'
  },
  text: {
    backgroundColor: theme.palette.background.dark,
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.background.dark}`,
    paddingLeft: '0.2rem',
    paddingRight: '0.2rem',
    marginLeft: '-14px',
    marginTop: '-14px',
    fontSize: '12px'
  }
}));

function UserProfileFeaturedCharacterDisplay(props) {
  const classes = useStyles();
  const { characterAssets } = useSelector(state => state.gameAssets);

  return (
    <Box mt={2} classes={{ root: classes.characterSlider }}>
      {map(props.data, (charData, idx) => {
        return (
          <Tooltip title={`View ${charData.name} Details`} key={charData.name}>
            <Badge
              overlap="circle"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              badgeContent={
                <Typography classes={{ root: classes.text }}>
                  {`C${charData.constellation}`}
                </Typography>
              }
            >
              <Avatar
                src={get(characterAssets[charData.name], 'avatar')}
                key={`${idx}-${charData.name}`}
                alt={charData.name}
                className={classes.characterImage}
                onClick={props.setModal(charData)}
              />
            </Badge>
          </Tooltip>
        );
      })}
      {isEmpty(props.data) && (
        <Typography style={{ fontSize: '12px', color: '#8c96a2' }}>
          No information to display.
        </Typography>
      )}
    </Box>
  );
}

UserProfileFeaturedCharacterDisplay.propTypes = {
  data: PropTypes.array.isRequired,
  classes: PropTypes.object,
  setModal: PropTypes.func.isRequired
};

export default UserProfileFeaturedCharacterDisplay;
